<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
      lg="4"
    >
      <v-btn
        color="primary"
        @click.prevent="initAutheticate"
      >
        Authenticate App
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'RunSignup',
  methods: {
    async initAutheticate() {
      const url = encodeURIComponent(`${window.location.protocol}//${window.location.host}/finalizeOauth`);
      window.location.href = `https://runsignup.com/Profile/OAuth2/RequestGrant?response_type=code&client_id=${process.env.VUE_APP_RUN_SIGNUP_CLIENT_ID}&scope=rsu_api_write%20rsu_api_read&redirect_uri=${url}&state=${this.$route.query.t}`;
    },
  },
};
</script>
